import React from 'react';

import { Icons } from '@shared/components/ui';

import FeatureCard from './FeatureCard';

const FEATURES = [
  {
    icon: <Icons.ChatBubble size="lg" />,
    title: 'Every Conversation, One Timeline',
    description:
      'Years of iMessage, WhatsApp, Skype, ICQ, Google Voice, and voicemail imported into one searchable history — threaded by person, not by whichever app you were using that year.',
  },
  {
    icon: <Icons.PenFancy size="lg" />,
    title: 'Study',
    description:
      'Long-form writing workspaces with version history and AI drafting alongside you — plus a teleprompter for when it is time to record.',
  },
  {
    icon: <Icons.Flask size="lg" />,
    title: 'Research',
    description:
      'Gather sources into collections, archive the full text so it cannot rot, clip what matters, and read it back without leaving Conway.',
  },
  {
    icon: <Icons.Utensils size="lg" />,
    title: 'Meal Planning',
    description:
      'Weekly menus with recipes, prep organization, and automatic grocery lists. Block out travel days so nothing goes to waste.',
  },
  {
    icon: <Icons.UserGroup size="lg" />,
    title: 'People',
    description:
      'One record per person, stitched together across every channel you have ever talked on, so history follows the human and not the handle.',
  },
  {
    icon: <Icons.Calendar size="lg" />,
    title: 'Schedule Awareness',
    description:
      'Your calendar and local forecast feed everything else — conflict and back-to-back detection, meeting prep, and meal plans that know you are travelling.',
  },
  {
    icon: <Icons.ReadLater size="lg" />,
    title: 'Reading Queue',
    description:
      'Save articles for later and let AI pull the best insights out of them for you, so a long queue still turns into something you know.',
  },
  {
    icon: <Icons.Sun size="lg" />,
    title: 'Daily Briefings',
    description:
      'A personalized briefing waiting before you are up: weather, your calendar, reminders, tasks, and a quote worth reading.',
  },
];

const FeaturesSection: React.FC = () => {
  return (
    <section id="features" className="px-4 py-16 sm:px-6 sm:py-24 lg:px-8">
      <div className="mx-auto max-w-6xl">
        <div className="mb-12 text-center sm:mb-16">
          <h2 className="text-foreground text-3xl font-light sm:text-4xl">
            More Areas, <strong className="font-semibold">Same Brain</strong>
          </h2>
          <p className="text-muted-foreground mx-auto mt-4 max-w-2xl text-lg">
            The areas above are where most days get spent. These are the rest — each one wired into
            the same stream, each one giving the others more to correlate against.
          </p>
        </div>
        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {FEATURES.map(feature => (
            <FeatureCard key={feature.title} {...feature} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
